// extracted by mini-css-extract-plugin
module.exports = {"buttons":"buttons__3gVVI","button":"button__3hTPx"};